import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('boot-buyer-guide', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./boot-buyer-guide-landing')
        ),
);
